module.exports = __webpack_public_path__ + "img/text-mark12.1028cb99.png";